import React, { Component } from 'react'
import { Link } from 'react-router-dom'

// Components
import DropdownButton from '../DropdownButton'

// Images
import Logo from '../../images/logo.svg'


// Constants
import { SOLUTIONS, SERVICES, MARKET, COMPANY } from './constants'


// Style
import './index.scss'

class Header extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isShadowVisible: false,
      isMenuVisible: false,
    }
  }

  componentDidMount = () => {
    this.addShadowToHeader()
  }

  // This will add shadow to our header when user scrolls
  addShadowToHeader = () => {
    window.addEventListener('scroll', () => {
      let top = window.pageYOffset
      if (top > 0) {
        this.setState({ isShadowVisible: true })
      } else if (top === 0) {
        this.setState({ isShadowVisible: false })
      }
    });
  }



  handleOpen = () => {
    this.setState({ isMenuVisible: true })
  }

  handleClose = () => {
    this.setState({ isMenuVisible: false })
  }

  render = () => {
    const { isMenuVisible, isShadowVisible } = this.state
    return (
      <header className="f-w" style={{ boxShadow: isShadowVisible ? '2px 4px 10px rgba(0,0,0,.2)' : 'none' }}>

        <div className="container flex vh-center">
          <div className="logo c-padd vh-center">
            <a href="/">
              <img src={Logo} alt="EIDIM - AV Technology" />
            </a>
          </div>

          <div className="menu">
            <div className={`overlay ${isMenuVisible ? 'show' : ''}`} onClick={this.handleClose}></div>
            <div className={`lg-menu ${isMenuVisible ? 'open' : ''}`}>
              <ul>
                <li>
                  <DropdownButton
                    id="headerSolutionMenu"
                    title="Services"
                    menuAlign="right"
                    menu={SERVICES}
                  />
                </li>

                <li>
                  <DropdownButton
                    id="headerSolutionMenu"
                    title="Solutions"
                    menuAlign="right"
                    menu={SOLUTIONS}
                  />
                </li>

                <li>
                  <DropdownButton
                    id="headerMarketMenu"
                    title="Market"
                    menuAlign="right"
                    menu={MARKET}
                  />
                </li>

                <li>
                  <DropdownButton
                    id="headerCompanyMenu"
                    title="Company"
                    menuAlign="right"
                    menu={COMPANY}
                  />
                </li>

                <li>
                  <a href="/contact-us">
                    <button className="btn header-btn">Contact Us</button>
                  </a>
                </li>


              </ul>
            </div>

            <div className="sm-menu">
              <ul className="vh-center">
                <li className="sm-menu">
                  <button className="btn header-btn" onClick={this.handleOpen}>Menu</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    )
  }
}

export default Header